import type { NavSection } from '@/components/layout/nav';
import type { EffectivePermission } from '@/stores/auth';

export type PermissionRequirement =
  | { any: EffectivePermission[] }
  | { all: EffectivePermission[] };

export function hasPermission(
  grants: EffectivePermission[],
  obj: string,
  act: string,
): boolean {
  return grants.some(
    (grant) =>
      (grant.obj === obj || grant.obj === '*') && (grant.act === act || grant.act === '*'),
  );
}

export function meetsRequirement(
  grants: EffectivePermission[],
  requirement?: PermissionRequirement,
): boolean {
  if (!requirement) return true;
  if ('any' in requirement) {
    return requirement.any.some((permission) =>
      hasPermission(grants, permission.obj, permission.act),
    );
  }
  return requirement.all.every((permission) =>
    hasPermission(grants, permission.obj, permission.act),
  );
}

export function filterNavSections(
  sections: NavSection[],
  grants: EffectivePermission[],
): NavSection[] {
  return sections
    .map((section) => ({
      ...section,
      items: section.items.filter((item) => meetsRequirement(grants, item.access)),
    }))
    .filter((section) => section.items.length > 0);
}
